import { lazy } from 'react';

const Dashboard = lazy(() => import('../pages/Dashboard'));
const PaymentTransactionsPage = lazy(() => import('../pages/Dashboard/PaymentTransactionsPage'));
const Products = lazy(() => import('../pages/Products'));
const Customers = lazy(() => import('../pages/Customer'));
const ZohoCustomers = lazy(() => import('../pages/ZohoCustomers'));
const Merchants = lazy(() => import('../pages/Merchants'));
// import MerchantDetails from '../pages/Merchants/MerchantDetails';
const CustomerDetails = lazy(() => import('../pages/Customer/CustomerDetails'));
const NewCustomer = lazy(() => import('../pages/Customer/NewCustomer'));
const NewProduct = lazy(() => import('../pages/Products/NewProduct'));
const Partners = lazy(() => import('../pages/Partners'));
const Integration = lazy(() => import('../pages/Integration'));
const Orders = lazy(() => import('../pages/Orders'));
const Sales = lazy(() => import('../pages/Sales'));
const Quotes = lazy(() => import('../pages/Quotes'));
const ZohoQuotes = lazy(() => import('../pages/Quotes/ZohoQuotes'));

const Settings = lazy(() => import('../pages/Settings'));
const Integrations = lazy(() => import('../pages/Integration/Integrations'));
const PartnerInformation = lazy(() => import('../pages/Partners/PartnerInformation'));
// import AllProducts from '../pages/Merchants/AllProducts';
// import AuthLayout from "./components/layouts/AuthLayout";

const ForgotPassword = lazy(() => import('../pages/Auth/ForgotPassword'));
const Login = lazy(() => import('../pages/Auth/Login'));
const OTP = lazy(() => import('../pages/Auth/OTP'));
const SignUp = lazy(() => import('../pages/Auth/SignUp'));
const IncorrectOTP = lazy(() => import('../pages/Auth/IncorrectOTP'));
const ConfirmOTP = lazy(() => import('../pages/Auth/ConfirmOTP'));
const HandoffReceiver = lazy(() => import('../pages/Auth/HandoffReceiver'));
const NewUser = lazy(() => import('../pages/Settings/NewUser'));
const ViewUser = lazy(() => import('../pages/Settings/ViewUser'));
// import NewMerchant from '../pages/Merchants/NewMerchant';
const Category = lazy(() => import('../pages/Products/Category'));
const AllProductsAvailable = lazy(() => import('../pages/Products/AllProductsAvailable'));
const ViewProduct = lazy(() => import('../pages/Products/ViewProduct'));
const OrderDetails = lazy(() => import('../pages/Orders/OrderDetails'));
const InStock = lazy(() => import('../pages/Products/InStock'));
const NewPartner = lazy(() => import('../pages/Partners/NewPartner'));
const RolePartnerDetails = lazy(() => import('../pages/Settings/RolePartnerDetails'));
const UpdateProduct = lazy(() => import('../pages/Products/updateProduct'));
const CategoriesPage = lazy(() => import('../pages/Categories'));
const BrandsPage = lazy(() => import('../pages/Brands'));
const NewCategory = lazy(() => import('../pages/Categories/NewCategory'));
const NewBrand = lazy(() => import('../pages/Brands/NewBrand'));
const BrandPages = lazy(() => import('../pages/BrandPages'));
const BrandPageEditor = lazy(() => import('../pages/BrandPages/BrandPageEditor'));
const NewArrivals = lazy(() => import('../pages/NewArrivals'));
const ResetPassword = lazy(() => import('../pages/Auth/ResetPassword'));
const ProductReturns = lazy(() => import('../pages/ProductReturns'));
const Returns = lazy(() => import('../pages/Returns'));
const Invoices = lazy(() => import('../pages/invoices'));
const ExchangeRates = lazy(() => import('../pages/Rates'));
const Withdrawals = lazy(() => import('../pages/Withdrawals'));
const SalesWithdrawals = lazy(() => import('../pages/SalesWithdrawals'));
const SampleRequests = lazy(() => import('../pages/SampleRequests'));
const FinanceRequests = lazy(() => import('../pages/FinanceRequests'));
const SourcingCategoriesPage = lazy(() => import('../pages/Sourcing/SourcingCategoriesPage'));
const SourcingRequestsPage = lazy(() => import('../pages/Sourcing/SourcingRequestsPage'));
const BackordersPage = lazy(() => import('../pages/Sourcing/BackordersPage'));
const SpecialSourcingRequests = lazy(() => import('../pages/SpecialSourcingRequests'));
const Tasks = lazy(() => import('../pages/Tasks'));
const EditGroupedProduct = lazy(() => import('../pages/grouped'));
const TemplateManagementSystem = lazy(() => import('../pages/NotificationsManager/TemplateManagementSystem'));
const NotificationsPage = lazy(() => import('../pages/Notifications'));
const NotificationRedirect = lazy(() => import('../pages/Notifications/NotificationRedirect'));
const AdminBargains = lazy(() => import('../pages/Dashboard/AdminBargains'));
const AdminInvoicesList = lazy(() => import('../pages/AdminInvoices'));
const AdminCreateInvoice = lazy(() => import('../pages/AdminInvoices/CreateInvoice'));
const SalesPartners = lazy(() => import('../pages/SalesPartners'));
const PendingOrders = lazy(() => import('../pages/PendingOrders'));
const TaxRates = lazy(() => import('../pages/TaxRates'));
const SeoSettings = lazy(() => import('../pages/SeoSettings'));
const SizeCharts = lazy(() => import('../pages/SizeCharts'));
const SizeChartEditor = lazy(() => import('../pages/SizeCharts/SizeChartEditor'));
const SizeChartPreview = lazy(() => import('../pages/SizeCharts/SizeChartPreview'));

export const authRoutes = [
  { path: "/login", element: <Login /> },
  { path: "/sign-up", element: <SignUp /> },
  { path: "/otp", element: <OTP /> },
  { path: "/incorrect-otp", element: <IncorrectOTP /> },
  { path: "/forgotPassword", element: <ForgotPassword /> },
  { path: "/reset-password", element: <ResetPassword /> },
  { path: "/confirm-otp", element: <ConfirmOTP /> },
  { path: "/oauth-success", element: <HandoffReceiver /> },
];

export const appRoutes = [
	{ path: "/", element: <Dashboard exact /> },
	{ path: "/dashboard/payments", element: <PaymentTransactionsPage /> },
	{ path: "/products", element: <Products /> },
	{ path: "/products/grouped/:id", element: <EditGroupedProduct /> },
	{ path: "/customers", element: <Customers /> },
	{ path: "/categories", element: <CategoriesPage /> },
	{ path: "/new-category", element: <NewCategory /> },
	{ path: "/new-category/:id", element: <NewCategory /> },
	{ path: "/sourcing/categories", element: <SourcingCategoriesPage /> },
	{ path: "/sourcing/requests", element: <SourcingRequestsPage /> },
	{ path: "/sourcing/backorders", element: <BackordersPage /> },
	{ path: "/brands", element: <BrandsPage /> },
	{ path: "/new-brand", element: <NewBrand /> },
	{ path: "/new-brand/:id", element: <NewBrand /> },
	{ path: "/brand-pages", element: <BrandPages /> },
	{ path: "/brand-pages/new", element: <BrandPageEditor /> },
	{ path: "/brand-pages/:id/edit", element: <BrandPageEditor /> },
	{ path: "/new-arrivals", element: <NewArrivals /> },
	{ path: "/sourcing/special-requests", element: <SpecialSourcingRequests /> },
	{ path: "/vendors", element: <Merchants /> },
	{ path: "/sales-partners", element: <SalesPartners /> },
	{ path: "/vendors-withdrawals", element: <Withdrawals /> },
	{ path: "/sales-withdrawals", element: <SalesWithdrawals /> },
	{ path: "/samples", element: <SampleRequests /> },
	{ path: "/bargains", element: <AdminBargains /> },
	{ path: "/finance-requests", element: <FinanceRequests /> },
	{ path: "/invoicing", element: <AdminInvoicesList /> },
	{ path: "/invoicing/create", element: <AdminCreateInvoice /> },
	{ path: "/tasks", element: <Tasks /> },
	// { path: '/vendors/:id', element: <MerchantDetails /> },
	{ path: "customers/customer-details/:id", element: <CustomerDetails /> },
	{ path: "/newCustomer", element: <NewCustomer /> },
	{ path: "/zoho-customers", element: <ZohoCustomers /> },
	{ path: "/partners", element: <Partners /> },
	{ path: "/integration", element: <Integration /> },
	{ path: "/integrations", element: <Integrations /> },
	{ path: "/orders", element: <Orders /> },
	{ path: "/pending-orders", element: <PendingOrders /> },
	{ path: "/salesorder", element: <Sales /> },
	{ path: "/rates", element: <ExchangeRates /> },
	{ path: "/tax-rates", element: <TaxRates /> },
	{ path: "/size-charts", element: <SizeCharts /> },
	{ path: "/size-charts/new", element: <SizeChartEditor /> },
	{ path: "/size-charts/:id/edit", element: <SizeChartEditor /> },
	{ path: "/size-charts/:id/preview", element: <SizeChartPreview /> },
	{ path: "/quotes", element: <Quotes /> },
	// Legacy read-only view straight off Zoho Books, kept reachable while the
	// local-first console beds in.
	{ path: "/quotes/zoho", element: <ZohoQuotes /> },
	{ path: "/invoices", element: <Invoices /> },
	{ path: "/returns", element: <Returns /> },
	// Legacy Zoho sales-returns view, kept reachable while the new flow beds in.
	{ path: "/returns/zoho", element: <ProductReturns /> },
	{ path: "/settings", element: <Settings /> },
	{ path: "/seo-settings", element: <SeoSettings /> },
	{ path: "/partners/partner-info/:id", element: <PartnerInformation /> },
	// { path: '/vendors/:vendorName/allProducts', element: <AllProducts /> },
	{ path: "/newProduct", element: <NewProduct /> },
	{ path: "/updateProduct", element: <UpdateProduct /> },
	{ path: "/settings/roles/newUser", element: <NewUser /> },
	{ path: "viewUser", element: <ViewUser /> },
	// { path: '/vendors/edit/:id', element: <NewMerchant /> },
	// { path: '/vendors/new', element: <NewMerchant /> },
	{ path: "/products/category/:id", element: <Category /> },
	{ path: "/allAvailableProducts", element: <AllProductsAvailable /> },
	{ path: "/viewProduct", element: <ViewProduct /> },
	{ path: "/orderDetails", element: <OrderDetails /> },
	{ path: "/products/:id", element: <InStock /> },
	{ path: "/partners/new-partner", element: <NewPartner /> },
	{ path: "/roles/partner-details/:id", element: <RolePartnerDetails /> },

	{ path: "/notificationsmanager", element: <TemplateManagementSystem /> },
	{ path: "/notifications", element: <NotificationsPage /> },
	{ path: "/n/:id", element: <NotificationRedirect /> },
];
